import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaWhatsapp,
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import "../styles/footer.css";
import logo from "../assets/logo.png";

// 🔥 Firebase
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [error, setError] = useState("");

  const clearErrorAfterDelay = () => {
    setTimeout(() => setError(""), 3000);
  };

  const handleSubscribe = async () => {
    setError("");

    if (!email || !email.includes("@")) {
      setError("Please enter a valid email!");
      clearErrorAfterDelay();
      return;
    }

    try {
      const q = query(
        collection(db, "newsletterSubscribers"),
        where("email", "==", email)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setError("Email already subscribed");
        clearErrorAfterDelay();
        return;
      }

      await addDoc(collection(db, "newsletterSubscribers"), {
        email,
        createdAt: serverTimestamp(),
      });

      setShowToast(true);
      setEmail("");
      setError("");

      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Try again.");
      clearErrorAfterDelay();
    }
  };

  return (
    <footer className="franchise-footer">
      {/* ================= MAIN FOOTER ================= */}
      <div className="footer-franchise">
        {/* LEFT */}
        <div className="franchise-list">
          <h3>Reach Us..</h3>

          <div className="franchise-grid">
            {[
              ["Coimbatore", "96771 12550"],
              ["Tiruvallur", "79044 95503"],
              ["Thoothukudi", "96291 96361"],
              ["Trichy", "86107 06322"],
              ["Ramanathapuram", "90801 93935"],
              ["Chennai", "99406 95555"],
              ["Theni", "97505 64000"],
              ["Virudhunagar", "98423 02700"],
              ["Tirunelveli", "63834 38852"],
              ["Sivagangai", "98423 02700"],
              ["Vijayawada", "70367 00100"],
              ["Namakkal", "75503 66778"],
              ["Erode", "75503 66778"],
              ["Madurai", "98423 02700"],
              
            ].map(([city, phone], i) => (
              <div key={i} className="franchise-item">
                <p className="city">{city}</p>
                <span>{phone}</span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="footer-contact">
          {/* NEWSLETTER */}
          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Get course updates & offers directly to your inbox.</p>

            <div className="newsletter-box">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button onClick={handleSubscribe}>Subscribe</button>
            </div>

            {error && <p className="error-text">{error}</p>}

            {showToast && (
              <div className="subscribe-toast">
                ✅ Successfully subscribed!
              </div>
            )}
          </div>

          {/* LOGO */}
          <img src={logo} alt="Sprout Logo" className="footer-logo-right" />

          {/* SOCIAL ICONS */}
          <div className="footer-social">
            <a href="#" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>

            <a
              href="https://www.instagram.com/sproutks.official"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.linkedin.com/company/sproutknowledge/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://x.com/sproutks"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61578866370856"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
          </div>

          {/* CONTACT */}
          <div className="footer-contact-info">
            <span className="contact-title">CONTACT</span>
            <p>info@sproutks.com</p>
            <p>+91 96771 12551</p>

            <p>hr@sproutks.com</p>
            <p>+91 96771 12550</p>
          </div>
        </div>
      </div>

      {/* ================= FOOTER LINKS ================= */}
      <div className="footer-links-bar">
        
        
        <Link to="/disclaimer">Disclaimer</Link>
<span>|</span>
<Link to="/privacy-policy">Privacy Policy</Link>
<span>|</span>
<Link to="/terms-and-conditions">Terms & Conditions</Link>
      </div>

      {/* ================= BOTTOM ================= */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Sprout Knowledge Solutions Pvt Ltd. All
          rights reserved.
        </p>
      </div>
    </footer>
  );
}